import { Link } from 'react-router-dom';
import SectionReveal from '../components/SectionReveal';
import './PlanPage.css';

function PlanPage({ title, subtitle, message, plans }) {
  return (
    <main className="plan-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero__content">
            <span className="section-badge">Plans</span>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <SectionReveal>
            <div className="plan-page__message">
              <p>{message}</p>
            </div>
          </SectionReveal>

          <div className="plan-page__grid">
            {plans.map((plan, idx) => (
              <PlanCard key={plan.id} plan={plan} delay={idx * 0.15} />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}

function PlanCard({ plan, delay }) {
  return (
    <SectionReveal delay={delay}>
      <Link to={`/plan/${plan.id}`} className="plan-card">
        <div className="plan-card__image-wrap">
          <img src={plan.image} alt={plan.header} className="plan-card__image" />
          <div className="plan-card__overlay">
            <h3 className="plan-card__header">{plan.header}</h3>
          </div>
        </div>
        <div className="plan-card__body">
          <div className="plan-card__details">
            <div className="plan-card__detail">
              <span className="plan-card__detail-label">Monthly Price</span>
              <span className="plan-card__detail-value plan-card__detail-value--price">₹{plan.monthlyPrice.toLocaleString('en-IN')}</span>
            </div>
            <div className="plan-card__detail">
              <span className="plan-card__detail-label">Selling Price per Cup</span>
              <span className="plan-card__detail-value">₹{plan.sellingPricePerCup}</span>
            </div>
            <div className="plan-card__detail">
              <span className="plan-card__detail-label">Plan Duration</span>
              <span className="plan-card__detail-value">{plan.planDurationDays} Days</span>
            </div>
          </div>

          <button
            className="btn btn-primary plan-card__view-btn"
            style={{ background: `linear-gradient(135deg, ${plan.color}, ${plan.color}dd)` }}
          >
            View Details
          </button>
        </div>
      </Link>
    </SectionReveal>
  );
}

export default PlanPage;
